// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { Modal, UseShowHide } from '@teamnine/pcj-ui-v2'

import { Template as ITemplate } from '@/services/templates'
import { useErrorHelper } from '@/app/shared/hooks/useErrorHelper'
import { useUpdateTemplatePublishedStatus } from '@/app/Templates/hooks/useUpdateTemplatePublishedStatus'

type PublishTemplateModalProps = {
  modal: UseShowHide
  template?: ITemplate
}

export default function PublishTemplateModal({
  modal,
  template,
}: PublishTemplateModalProps) {
  const { basicErrorHandler, displayGlobalMessage } = useErrorHelper()
  const { mutateAsync: updateTemplatePublishedStatus, isLoading } =
    useUpdateTemplatePublishedStatus()

  const onPublishTemplate = async () => {
    if (!template?.id) return
    try {
      await updateTemplatePublishedStatus(template)
      displayGlobalMessage({
        heading: 'Template successfully published.',
        type: 'success',
      })

      modal.hide()
    } catch (err) {
      basicErrorHandler(err)
    }
  }

  return (
    <Modal open={modal.visible} onOpenChange={modal.toggle}>
      <Modal.Display aria-label="Publish Template">
        <Modal.Header title="Publish Template" />
        <Modal.Content>
          Are you sure you want to publish this template? This cannot be undone.
        </Modal.Content>
        <Modal.Footer
          footerAction={{
            primaryButton: {
              label: 'Confirm',
              type: 'button',
              onClick: onPublishTemplate,
              loading: isLoading,
            },
            secondaryButton: {
              label: 'Cancel',
              closeModal: true,
            },
          }}
        />
      </Modal.Display>
    </Modal>
  )
}
